const __request = require(`./__request/`);
/**
 * 酒店订单详情
 */
export default function (val) {
    var pParameter = {}
    pParameter.method = "POST"
    // pParameter.urlSuffix = "/hotel/manager/order/queryHotelOrderDetails"

    pParameter.urlSuffix = "/hotel/baseOrder/queryHotelOrderDetails"
    pParameter.data = val
    return new Promise(function (resolve, reject) {
        resolve(__request(pParameter))
    })
}
